import { Component, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ToggleComponent } from '@rensa/shared/classes/toggle-component';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.css']
})
export class CheckboxComponent extends ToggleComponent {
    constructor(@Self() @Optional() control: NgControl) {
        super(control);
    }
}
